import {VideoService} from "../../serverService/videos/VideoService";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {
    addNewRowToTable,
    convertUniversalDateTimeToPersianDateTime, DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoCustomTable,
    RaikoDefaultDialogPage, RaikoGridOneColumn, RaikoTableTitleContainer,
    showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {RouteHelper} from "../../route/RouteHelper";
import SliderAddNewSlide from "../sliders/SliderAddNewSlide";
import AddNewVideos from "./AddNewVideos";
import {Helmet} from "react-helmet";

export default function Videos() {

    const size = 25
    let page = 0

    const service = new VideoService()

    const [totalItems, setTotalItems] = useState("")
    const [videos, setVideos] = useState([]);
    const [tableLoading, setTableLoading] = useState(false)
    const [pageCount, setPageCount] = useState(0);

    const navigate = useNavigate()

    useEffect(() => {
        getDataFromServer()
    }, []);


    function handleChangePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    function getDataFromServer() {
        setTableLoading(true)
        service.getVideosList(
            page, size
        ).then(response => {
            setTotalItems(response.numberOfItems)
            setPageCount(response.totalPage)

            setVideos([])
            response.data.map((item, index) => {
                setVideos(prev => [
                    ...prev,
                    prepareVideoClipItem(
                        item.id,
                        (page * size) + index + 1,
                        item.title,
                        item.postedAt,
                        item.enabled
                    )
                ])
            })

        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    function prepareVideoClipItem(id, number, title, postedAt, enabled) {
        return {
            id,
            number,
            title,
            postedAt: convertUniversalDateTimeToPersianDateTime(postedAt)
        }
    }

    function handleSelectRow(_item) {
        let _title = ""
        videos.map((item) => {
            if (item.id === _item)
                _title = item.title
        })

        navigate(
            RouteHelper.MagazineVideoDetail.globalUrl.replace(":id", _item),
            {state: {title: _title}, replace: false}
        )
    }

    const [openDialog, setOpenDialog] = useState(false)

    const handleOpenDialog = () => setOpenDialog(true)
    const handleCloseDialog = () => setOpenDialog(false)

    function handleAddVideoToList(item) {
        const newSliders = addNewRowToTable(
            prepareVideoClipItem(
                item.id,
                1,
                item.title,
                item.postedAt,
                item.enabled
            ),
            videos
        )


        setVideos(newSliders)
        handleCloseDialog()
    }


    return (
        <>
            <Helmet>
                <title>{RouteHelper.MagazineVideos.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialog}
                pageTitle={"افزودن کلیپ جدید"}
                dialogSize={DialogSize.LARGE}
            >
                <AddNewVideos handleAddVideoToList={handleAddVideoToList}/>
            </RaikoDefaultDialogPage>

            <RaikoBaseContainer>
                <RaikoBreadcrumb breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.Magazine.name,
                        ""
                    ),
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.MagazineVideos.name,
                        RouteHelper.MagazineVideos.globalUrl
                    )
                ]}/>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"کلیپ ها"}
                            amount={totalItems}
                            hasCreateNewItem
                            handleCreateNewItem={handleOpenDialog}
                        />
                        <RaikoCustomTable
                            header={header}
                            data={videos}
                            isLoading={tableLoading}
                            newPage={page}
                            pageCount={pageCount}
                            handlePaginationChange={handleChangePagination}
                            rowClicked={handleSelectRow}
                        />
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoBaseContainer>
        </>
    )
}


const header = [
    {
        id: "number",
        label: "#"
    }, {
        id: "title",
        label: "عنوان"
    }, {
        id: "postedAt",
        label: "تاریخ"
    },
]
